<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12 titulo-paso">CSV GMV (Obligatorio)</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<b-button id="seguir" variant="success" v-on:click="seguir" :disabled="!disabled">SEGUIR</b-button>
					<hr />
				</div>
			</div>
			<div class="row">
				<div class="col-10">
					<label class="control-label">A continuación: sube el archivo con la planilla completa</label>
					<upload-excel type="xls" :on-success="onSuccess" :before-upload="beforeUpload" />
				</div>
			</div>
			<p></p>
			<div v-if="error" class="row">
				<div class="col-12 text-center">
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12">
							<h5><i class="fas fa-exclamation fa-fw" /> {{ mensaje }}</h5>
						</div>
					</div>
				</div>
			</div>
			<p></p>
			<div v-if="validacion" class="row">
				<div class="col-12">
					<div class="row">
						<div class="col-8 offset-1 text-center">
							<div><hr style="margin-bottom: 5px"/></div>
							<div><b>TOTAL GMV</b></div>
							<div><hr style="margin-top: 5px"/></div>
							<div>{{ Intl.NumberFormat("es-CL").format(totalGMV) }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import UploadExcel from "./upload_excel.vue"


	export default 
	{
		name: "Paso3",
		components: { UploadExcel },
		props: {
			periodo: "",
			confirmacion: false,
			onAvanzar: Function, // Funcion callback para la accion de avanzar en el wizard
			onArchivo: Function, // Funcion callback para informar sobre el archivo cargado
		},
		data() {
			return {
				nombre: "gmv", // Tipo de archivo a cargar
				mes: "",
				disabled: false, // Flag que controla el boton SEGUIR
				validacion: false,
				totalGMV: 0,
				glosa1: "GMV - Discounts",
				glosa2: "Total",
				error: false, // Flag que controla cuando mostrar el mensaje de error 
				mensaje: "",
			}
		},
		created() {

			// Rutina para convertir el mes seleccionado desde numero a nombre (Ej.: 5 - mayo)
			var tmp = this.periodo.split("-")
			var hoy = new Date()
			var fecha = new Date(hoy.getFullYear(), parseInt(tmp[1]) - 1, 1)
			this.mes = fecha.toLocaleString("default", { month: "long" })
		},
		methods: {

			// Se ejecuta antes de comenzar a leer el archivo
			// Sirve para activar el icono de espera
			beforeUpload() {

				this.error = false

				// Activamos la imagen "cargando"
				window.event.$emit("mostrar-cargando", true)

				return true
			},

			// Se ejecuta una vez que se leyo todo el archivo
			// Desactiva el icono de espera y muestra el Total GMV en pantalla
			// Si no hubo error con el archivo, se informa al padre (main.vue) sobre el archivo cargado
			// y se activa el boton SEGUIR
			onSuccess(header, data, file) {

				// Ocultamos la imagen "cargando"
				window.event.$emit("mostrar-cargando", false)

				// Recorremos los registros para obtener la fila de totales
				var fila = 0
				var key = ""
				for (var registro of data)
				{
					// Saltamos los registros anteriores
					// Deberiamos validar por si el archivo trae un año diferente al seleccionado ????
					if (fila < 1)
					{
						fila++
						continue
					}

					// El segundo registro tra la informacion de los meses a procesar
					// Lo leemos y obtenemos la columna equivalente al mes en proceso
					if (fila == 1)
					{
						// Obtenemos el nombre del campo que corresponde al mes en proceso
						key = Object.keys(registro).find(key => registro[key] == this.mes)

						// Pasamos al siguiente registro
						fila++
						continue
					}

					// Si los datos del registro corresponden con los datos del Total GMV, guardamos el monto y salimos del ciclo
					if (registro.__EMPTY == this.glosa1 && registro.__EMPTY_1 == this.glosa2)
					{
						this.totalGMV = registro[key]

						break
					}

					fila++
				}

				// Si el archivo no trae informacion para el mes en proceso salimos y mostramos un mensaje
				if (key == undefined) {

					this.mensaje = "No hay información para el mes <b>" + this.mes + "</b>"
					this.error = true
					this.validacion = false
				} else {

					this.validacion = true 
					this.procesar()

					// Llamamos a la funcion callback para enviar la info del archivo cargado
					if (this.onArchivo)
						this.onArchivo({ archivo: this.nombre, nombre: file.name, tipo: file.type, tamanio: file.size, registros: data.length, avance: 0 })
				}
			},

			// Enviamos la informacion al servidor y anvazamos de paso
			procesar() {

				// Estructura con la info que se enviara al servidor
				var request = {
					"usuario": this.$usuario, 
					"destino": this.$env,
					"tx": "F0",
					"proceso": "upDataFac",
					"archivo": this.nombre,
					"periodo": this.periodo,
					"data": [ { "gmv": this.totalGMV } ] 
				}	

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }) .then(response => {

					if (response.data.estatus == "OK")
						this.disabled = true // Activamos el boton SEGUIR
					else {

						this.mensaje = response.data.estatus
						this.error = true
					}

				}).catch(ex => {

					// Si hubo un error, pasamos por aca y registramos el mensaje
					console.log(ex.message)
				})
			},

			seguir() {

				// Llamamos a la funcion callback
				if (this.onAvanzar)
					this.onAvanzar()
			}
		}
	}

</script>
